import { isNotNull } from '@ramp106/omrjs-common'
import { type RouteLocationNormalized } from 'vue-router'

import { ReviewInteractionType } from '@/components/ReviewsCommon/ReviewInteractionStatus/types'
import { RecommendationRatingKeyEnum, SurveyResponsesStateEnum, SurveyResponsesViewEnum } from '@/gql/reviews'
import { checkEnumValue } from '@/helpers/checkEnumValue.ts'
import { getQueryStringArrayValue } from '@/helpers/getQueryStringArrayValue.ts'

import { TimeFrameOptionsEnum, type ReviewsSortAndFilter } from './types.ts'

export const reviewsSortAndFilterParamsFromQuery = (query: RouteLocationNormalized['query']): ReviewsSortAndFilter => {
  const { timeframe, purpose, rating, state, interaction, view } = query

  return {
    timeframe: checkEnumValue(timeframe, TimeFrameOptionsEnum, TimeFrameOptionsEnum.NONE),
    purposes: getQueryStringArrayValue(purpose).filter(isNotNull),
    ratings: getQueryStringArrayValue(rating)
      .map((value) => checkEnumValue(value, RecommendationRatingKeyEnum, null))
      .filter(isNotNull),
    states: getQueryStringArrayValue(state)
      .map((value) => checkEnumValue(value, SurveyResponsesStateEnum, null))
      .filter(isNotNull),
    interaction: checkEnumValue(interaction, ReviewInteractionType, ReviewInteractionType.NONE),
    view: checkEnumValue(view, SurveyResponsesViewEnum, SurveyResponsesViewEnum.All),
  }
}
